// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1GmS3","toggleWrap":"styles_toggleWrap__6i8Vh","content":"styles_content__2wpav","selectAreaCode":"styles_selectAreaCode__77LeZ"};